"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useDataFetcher2 = _interopRequireDefault(require("../../../Hooks/useDataFetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _default = function _default(_ref) {
  var mockData = _ref.mockData,
      RenderComponent = _ref.RenderComponent,
      _ref$query = _ref.query,
      query = _ref$query === void 0 ? "Activity.queries.list" : _ref$query,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? {} : _ref$variables,
      _ref$dataKey = _ref.dataKey,
      dataKey = _ref$dataKey === void 0 ? 'listActivitys' : _ref$dataKey,
      subscriptionUpdateDataKey = _ref.subscriptionUpdateDataKey,
      subscriptionUpdateVariables = _ref.subscriptionUpdateVariables,
      subscriptionUpdateMutation = _ref.subscriptionUpdateMutation,
      subscriptionCreateDataKey = _ref.subscriptionCreateDataKey,
      subscriptionCreateVariables = _ref.subscriptionCreateVariables,
      subscriptionCreateMutation = _ref.subscriptionCreateMutation,
      subscriptionUpdateQuery = _ref.subscriptionUpdateQuery,
      viewVariables = _ref.viewVariables,
      _ref$clientFilter = _ref.clientFilter,
      clientFilter = _ref$clientFilter === void 0 ? function (item) {
    return !!item;
  } : _ref$clientFilter,
      clientSort = _ref.clientSort,
      _ref$prependedObjects = _ref.prependedObjects,
      prependedObjects = _ref$prependedObjects === void 0 ? [] : _ref$prependedObjects,
      DataListView = _ref.DataListView,
      noPoll = _ref.noPoll,
      useButton = _ref.useButton,
      usedButton = _ref.usedButton,
      forceMore = _ref.forceMore,
      onLoading = _ref.onLoading,
      onLoaded = _ref.onLoaded,
      onItemsChange = _ref.onItemsChange,
      doClear = _ref.doClear,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? function (items) {
    return items;
  } : _ref$transform,
      onScroll = _ref.onScroll;

  var _useDataFetcher = (0, _useDataFetcher2["default"])({
    mockData: mockData,
    query: query,
    variables: variables,
    dataKey: dataKey,
    noPoll: noPoll,
    subscriptionCreateDataKey: subscriptionCreateDataKey,
    subscriptionCreateVariables: subscriptionCreateVariables,
    subscriptionCreateMutation: subscriptionCreateMutation,
    subscriptionUpdateDataKey: subscriptionUpdateDataKey,
    subscriptionUpdateVariables: subscriptionUpdateVariables,
    subscriptionUpdateMutation: subscriptionUpdateMutation,
    subscriptionUpdateQuery: subscriptionUpdateQuery,
    onItemsChange: onItemsChange
  }),
      objects = _useDataFetcher.objects,
      refetch = _useDataFetcher.refetch,
      error = _useDataFetcher.error,
      nextToken = _useDataFetcher.nextToken,
      loading = _useDataFetcher.loading,
      onCreateLoading = _useDataFetcher.onCreateLoading,
      onUpdateLoading = _useDataFetcher.onUpdateLoading,
      handleEndReached = _useDataFetcher.handleEndReached,
      handleRefresh = _useDataFetcher.handleRefresh,
      clearResults = _useDataFetcher.clearResults;

  var memoizedObjects = (0, _react.useMemo)(function () {
    return transform([].concat(_toConsumableArray(prependedObjects), _toConsumableArray(objects.filter(function (obj) {
      return !prependedObjects.find(function (po) {
        return po.id === obj.id;
      });
    }))));
  }, [JSON.stringify([].concat(_toConsumableArray(prependedObjects), _toConsumableArray(objects)))]);
  (0, _react.useEffect)(function () {
    !!onLoading && onLoading(loading);
  }, [loading]);
  (0, _react.useEffect)(function () {
    !!onLoaded && onLoaded(nextToken);
  }, [nextToken]);
  !!doClear && setTimeout(clearResults, 3000);
  return (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(DataListView, {
      onScroll: onScroll,
      objects: memoizedObjects,
      onEndReached: handleEndReached,
      RenderComponent: RenderComponent,
      viewVariables: viewVariables,
      clientFilter: clientFilter,
      clientSort: clientSort,
      hasMoreItems: !!nextToken,
      loading: loading,
      useButton: useButton,
      usedButton: usedButton,
      forceMore: forceMore
    });
  }, [memoizedObjects, handleEndReached, handleRefresh, onCreateLoading, onUpdateLoading, useButton, forceMore, loading]); //, clientFilter, ])
};

exports["default"] = _default;